import { render, staticRenderFns } from "./Portlet.vue?vue&type=template&id=1836f946&scoped=true&"
import script from "./Portlet.vue?vue&type=script&lang=js&"
export * from "./Portlet.vue?vue&type=script&lang=js&"
import style0 from "./Portlet.vue?vue&type=style&index=0&id=1836f946&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1836f946",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCard,VCardTitle,VSkeletonLoader,VTextField,VToolbar,VToolbarTitle})
